<script>
  export let text;
</script>

{text}
